<template>
  <div class="activity-record">
    <Navbar title="活动记录"></Navbar>
    <!-- 活动标题 -->
    <div class="activity-title">
      <span v-if="detail.master" class="activity-icon">主</span>
      <span v-if="!detail.master" class="activity-icon copy">副</span>
      <span class="name">{{ detail.name }}</span>
      <div class="label">
        <div class="label1">已发布</div>
        <div v-if="detail.enableReward" class="label2">分销开启</div>
        <div v-if="!detail.enableReward" class="label3">分销关闭</div>
      </div>
    </div>
    <!-- 活动详情 -->
    <div class="activity-detail">
      <div>开始时间：{{ detail.startTime }}</div>
      <div>结束时间：{{ detail.endTime }}</div>
      <div>价格：{{ detail.price }}</div>
      <div class="sale">
        <span>卖出：{{ saleNum }}个</span>
        <span v-if="saleNum > 0" class="sale-detail" @click="toSale">
          点击查看
        </span>
      </div>
      <div class="rule">
        <div>活动规则：</div>
        <div>{{ detail.rule }}</div>
      </div>
    </div>
    <!-- 操作按钮 -->
    <div class="btn">
      <van-button color="#F40001" @click="handleDelete">删除</van-button>
      <van-button
        v-if="detail.enableReward"
        color="#F49800"
        @click="handleDistribution"
      >
        关闭分销
      </van-button>
      <van-button
        v-if="!detail.enableReward"
        color="#adadad"
        @click="handleDistribution"
      >
        开启分销
      </van-button>
      <van-button color="#F49800" @click="handleEdit">修改</van-button>
      <van-button color="#007AFF" @click="toDetail">查看</van-button>
      <van-button
        v-if="detail.master && !detail.expired"
        color="#61A914"
        @click="handleCopy"
      >
        复制
      </van-button>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { Dialog } from "vant";
import {
  activityDetail,
  distribution,
  copyPromotion,
  deletePromotion
} from "@/api/activity";
import { orderList } from "@/api/order";

export default {
  components: {
    Navbar
  },
  data() {
    return {
      id: "",
      detail: {},
      listQuery: {
        page: 1,
        size: 1000,
        phone: "",
        status: "",
        promotionId: ""
      },
      saleNum: 0
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetail(this.id);
    this.listQuery.promotionId = this.id;
    this.getOrderList();
  },
  methods: {
    // 活动详情
    getDetail(id) {
      activityDetail(id).then(res => {
        // console.log("活动详情 :>> ", res);
        for (let i = 0; i < res.serviceItems.length; i++) {
          let { itemName, quantity, unitPrice, unit } = res.serviceItems[i];
          let tempVal = {
            itemName: itemName,
            unitPrice: unitPrice / 100,
            quantity: quantity,
            unit: unit
          };
          res.serviceItems[i] = tempVal;
        }
        res.price /= 100;
        res.startTime = res.startTime.slice(0, 10);
        res.endTime = res.endTime.slice(0, 10);
        res.activateStartTime = res.activateStartTime.slice(0, 10);
        res.activateEndTime = res.activateEndTime.slice(0, 10);
        localStorage.setItem("editData", JSON.stringify(res));
        this.detail = res;
      });
    },
    // 卖出数量
    getOrderList() {
      orderList(this.listQuery).then(res => {
        // console.log("卖出数量 :>> ", res);
        this.saleNum = res.length;
      });
    },
    // 跳转销售记录
    toSale() {
      this.$router.push({ name: "Sale", query: { id: this.id } });
    },
    // 删除
    handleDelete() {
      Dialog.confirm({
        title: "温馨提示",
        message: "您确定删除该活动吗？"
      }).then(() => {
        deletePromotion(this.id).then(res => {
          // console.log("复制 :>> ", res);
          if (res.code === 0) {
            this.$toast("删除成功");
            this.$router.go(-1);
          }
        });
      });
    },
    // 关闭分销
    handleDistribution() {
      let data = {
        id: this.id,
        enabled: this.detail.enableReward ? 0 : 1
      };
      distribution(data).then(res => {
        // console.log("关闭分销 :>> ", res);
        if (res.code === 0) {
          if (this.detail.enableReward) {
            this.$toast("已关闭");
          } else {
            this.$toast("已开启");
          }
          this.getDetail(this.id);
        }
      });
    },
    // 修改
    handleEdit() {
      this.$router.push("/activity/edit");
    },
    // 查看
    toDetail() {
      console.log(this.$activityShare + this.id)
      window.location.href = this.$activityShare + this.id;
    },
    // 复制
    handleCopy() {
      Dialog.confirm({
        title: "温馨提示",
        message: "您确定复制该活动吗？"
      }).then(() => {
        copyPromotion(this.id).then(res => {
          // console.log("复制 :>> ", res);
          if (res.code === 0) {
            this.$toast("复制成功");
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.activity-record {
  margin: 10px 20px;
  text-align: left;

  .activity-title {
    margin-bottom: 20px;
    border-bottom: 1px solid #000;

    .activity-icon {
      display: inline-block;
      height: 20px;
      width: 20px;
      margin-right: 5px;
      background-color: #007aff;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
      color: #fff;
    }

    .copy {
      background-color: #f08300;
    }

    .name {
      display: inline-block;
      margin-bottom: 20px;
      text-align: left;
    }

    .label {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      div {
        padding: 5px 10px;
        border: 1px solid #f08300;
        color: #f08300;
        border-radius: 5px;
      }

      .label1 {
        margin-right: 10px;
      }

      .label3 {
        color: #adadad;
        border-color: #adadad;
      }
    }
  }

  .activity-detail {
    margin-bottom: 20px;
    border-bottom: 1px solid #000;
    text-align: left;

    div {
      margin-bottom: 10px;
    }

    .sale {
      .sale-detail {
        margin-left: 10px;
        color: blue;
      }
    }

    .rule {
      margin-bottom: 20px;
      white-space: pre-line;
    }
  }

  .btn {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .van-button {
      margin-bottom: 10px;
      border-radius: 5px;
    }
  }
}
</style>
